// Display fallbacks for agent references when the backend doesn't send a title
// or the frontend can't resolve one.

/** File-upload references (FILE_UPLOAD_CHUNK / FILE_UPLOAD_FULL / USER_FILE_QDRANT_CHUNK). */
export const kUnnamedFileFallback = 'Unnamed File'

/** Caselaw references with no bluebook citation or title. */
export const kUntitledCaseFallback = 'Untitled Case'

/** LRR references with no name, citation, or slug. */
export const kUntitledLawFallback = 'Untitled Law'

/** Writing sample references with no title. */
export const kUnnamedWritingSampleFallback = 'Unnamed Writing Sample'

/** Default for any reference type without a more specific fallback. */
export const kUnnamedReferenceFallback = 'Unnamed Reference'

/** Tooltip for citations whose id can't be mapped to a reference — chat (mid-stream
 * or unknown ids) and canvas (ids carried across artifact versions) share it. */
export const kUnverifiedSourceLabel = 'Not linked — verify independently'

/** Chat badge label for unverified citations, rendered as [?]. */
export const kUnverifiedCitationLabel = '?'
